<template>
  <div class="recommend-container">
    <div class="banner-container">
      <img src="@/assets/images/recommend/header.png" alt="">
    </div>
    <div class="button-container">
      <img @click="handleApp" src="@/assets/images/recommend/recommend-btn.png" >
    </div>
    <div class="card-container">
      <div class="card-header">
      </div>
<!--      <div class="fold-container" v-if="foldDisplay">-->
<!--        <img @click="foldDisplay=false" src="@/assets/images/recommend/fold_02.png">-->
<!--      </div>-->
<!--      <div v-show="tag===2" class="hidden-container">-->
<!--        <div class="down-step">-->
<!--          <img src="@/assets/images/recommend/down-step.png">-->
<!--        </div>-->
<!--        <div class="credit">-->
<!--          <img src="@/assets/images/recommend/credit_03.png">-->
<!--        </div>-->
<!--        <div class="card-part1">-->
<!--          <div class="credit-line">-->
<!--            <div class="part1-dot"></div>-->
<!--            <div class="part1-text">被邀请者</div>-->
<!--            <div class="text-container">{{creditList[2].addScore}}</div>-->
<!--            <div class="points-text">积分</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="card-part2">-->
<!--          <div class="credit-line">-->
<!--            <div class="part1-dot"></div>-->
<!--            <div class="part1-text">被邀请者</div>-->
<!--            <div class="text-container">{{result.toDriverAwardPoint}}</div>-->
<!--            <div class="points-text">积分</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div v-show="tag===2" class="footer-container">-->
<!--        <div class="card-footer">-->
<!--          <div class="footer-title">如果您对江淮车型感兴趣，请留下您的信息</div>-->
<!--          <SaveInfoRecommend></SaveInfoRecommend>-->
<!--        </div>-->
<!--        <div class="instruction"></div>-->
<!--      </div>-->
      <div v-show="tag===1" class="hidden-container2">
        <div class="top-image"></div>
        <div class="mid-bgc" v-show="isDisplay">
          <div class="credit-line">
            <div class="part1-dot"></div>
            <div class="part1-text">一级邀请者</div>
            <div class="text-container">{{creditList[0].addScore}}</div>
            <div class="points-text">积分</div>
          </div>
          <div class="credit-line">
            <div class="part1-dot"></div>
            <div class="part1-text">二级邀请者</div>
            <div class="text-container">{{creditList[1].addScore}}</div>
            <div class="points-text">积分</div>
          </div>
        </div>
        <div class="bottom-image"  v-show="isDisplay">
          <div class="credit-line">
            <div class="part1-dot"></div>
            <div class="part1-text">一级邀请者</div>
            <div class="text-container">{{result.fromDriverAwardPoint}}</div>
            <div class="points-text">积分 上限{{result.awardCountUpperLimit}}人/月</div>
          </div>
          <div class="credit-line">
            <div class="part1-dot"></div>
            <div class="part1-text">二级邀请者</div>
            <div class="text-container">{{result.secondFromDriverAwardPoint}}</div>
            <div class="points-text">积分 上限{{result.secondAwardCountUpperLimit}}人/月</div>
          </div>
        </div>
      </div>
      <div class="instruction"></div>
      <transition name="slide-fade">
        <div v-show="btnDisplay" @click="handleApp" class="button-container">
        </div>
      </transition>
    </div>
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.4.0.js"></script>
<script>
import SaveInfoRecommend from '@/components/SaveInfoRecommendNew.vue'
import { getCredit, getCreditList } from '@/api/recommend'

export default {
  name: 'national-agent',
  components: { SaveInfoRecommend },
  data() {
    return {
      foldDisplay: true,
      test: 1,
      tag: 1,
      btn1: 'referee-ckd',
      btn2: 'recommender',
      btnDisplay: false,
      creditList: [{ addScore: '', ruelName: '' }, { addScore: '', ruelName: '' }],
      result: {
        awardCountUpperLimit: '',  //一级奖励人数上限
        fromDriverAwardPoint: '',//一级邀请人
        secondFromDriverAwardPoint: '', // 二级邀请人
        toDriverAwardPoint: '', //被邀请人
        secondAwardCountUpperLimit: '' // 二级邀请者人数上限
      },
      isDisplay: true
    }
  },
  created() {
    this.getCredit()
  },
  mounted() {
    const throttle = (fn, wait = 50) => {
      // 上一次执行 fn 的时间
      let previous = 0
      // 将 throttle 处理结果当作函数返回
      return function (...args) {
        // 获取当前时间，转换成时间戳，单位毫秒
        const now = +new Date()
        // 将当前时间和上一次执行函数的时间进行对比
        // 大于等待时间就把 previous 设置为当前时间并执行函数 fn
        if (now - previous > wait) {
          previous = now
          fn.apply(this, args)
        }
      }
    }
    // const that = this
    this.throttleLoad = throttle(this.scrollHander, 100)
    window.addEventListener('scroll', this.throttleLoad)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHander)
  },
  methods: {
    getLocation() {

    },
    getCredit() {
      getCredit({ list: ['56', '66','1'] })
        .then((res) => {
          this.creditList = res.data
        })
      getCreditList({})
        .then((res) => {
          this.result = res.data
        })
    },
    scrollHander() {
      const position = document.documentElement.scrollTop
      // console.log(position)
      if (position > 900) {
        this.btnDisplay = true
      } else {
        this.btnDisplay = false
      }
    },
    handleRecommender() {
      this.tag = 2
      this.btn2 = 'recommender-ckd'
      this.btn1 = 'referee'
    },
    handleReferee() {
      this.tag = 1
      this.btn2 = 'recommender'
      this.btn1 = 'referee-ckd'
    },
    handleApp() {
      document.location = 'activity://handle-recommend'
    }
  }
}
</script>

<style scoped lang="scss">
.recommend-container {
  background-color: #FACE9B;
  height: 100%;
  overflow: auto;
  img {
    width: 100%;
    display: block;
  }
  .button-container{
    margin-bottom: rem(42);
    img {
      width: rem(620);
      margin-right: auto;
      margin-left: auto;
    }
  }
  .card-container{
    position: relative;
    .card-header{
      height: rem(203);
      background-image: url('../../assets/images/recommend/card-header2.png');
      width: rem(752);
      margin-right: auto;
      margin-left: auto;
      background-size: contain;
      display: flex;
      .referee{
        height: rem(64);
        background-image: url('../../assets/images/recommend/referee-unckd.png');
        width: rem(311);
        margin-right: auto;
        margin-left: auto;
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        top: rem(42);
        left: rem(52);
      }
      .recommender{
        height: rem(64);
        background-image: url('../../assets/images/recommend/recommender-unckd.png');
        width: rem(311);
        margin-right: auto;
        margin-left: auto;
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        top: rem(42);
        right: rem(52);
      }
      .referee-ckd{
        height: rem(64);
        background-image: url('../../assets/images/recommend/referee-ckd.png');
        width: rem(311);
        margin-right: auto;
        margin-left: auto;
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        top: rem(42);
        left: rem(52);
      }
      .recommender-ckd{
        height: rem(64);
        background-image: url('../../assets/images/recommend/recommender-ckd.png');
        width: rem(311);
        margin-right: auto;
        margin-left: auto;
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        top: rem(42);
        right: rem(52);
      }
    }
    //.fold-container{
    //  position: absolute;
    //  z-index: 2;
    //  bottom: rem(-200);
    //}
    //.hidden-container{
    //  .down-step{
    //    width: rem(750);
    //    margin-left: auto;
    //    margin-right: auto;
    //  }
    //  .credit{
    //    width: rem(750);
    //    margin-left: auto;
    //    margin-right: auto;
    //  }
    //  .card-part1{
    //    background-image: url('../../assets/images/recommend/card-part1_03.png');
    //    height: rem(790);
    //    width: rem(750);
    //    margin-left: auto;
    //    margin-right:auto;
    //    background-size: contain;
    //    .credit-line{
    //      width: rem(550);
    //      height: rem(48);
    //      border-radius: rem(24);
    //      background-color: #FEF3DB;
    //      margin-right: auto;
    //      margin-left: auto;
    //      position: relative;
    //      .part1-dot{
    //        background-color: #FF7B59;
    //        width: rem(10);
    //        height: rem(10);
    //        border-radius: rem(5);
    //        position: absolute;
    //        top: rem(19);
    //        left: rem(16);
    //      }
    //      .part1-text{
    //        font-size: rem(28);
    //        font-family: Source Han Sans CN;
    //        font-weight: 400;
    //        color: #690B00;
    //        line-height: rem(40);
    //        padding-top: rem(7);
    //        position: absolute;
    //        left: rem(51);
    //      }
    //    .text-container{
    //      font-size: rem(36);
    //      font-family: Source Han Sans CN;
    //      font-weight: bold;
    //      color: #E43425;
    //      padding-top: rem(7);
    //      line-height: rem(40);
    //      position: absolute;
    //      right: rem(86);
    //    }
    //      .points-text{
    //        font-size: rem(28);
    //        font-family: Source Han Sans CN;
    //        font-weight: 400;
    //        color: #666666;
    //        padding-top: rem(8);
    //        line-height: rem(40);
    //        position: absolute;
    //        right: rem(20);
    //      }
    //    }
    //  }
    //  .card-part2{
    //    background-image: url('../../assets/images/recommend/card-part2.png');
    //    height: rem(372);
    //    width: rem(750);
    //    margin-left: auto;
    //    margin-right: auto;
    //    background-size: contain;
    //    background-repeat: no-repeat;
    //    .credit-line{
    //      width: rem(550);
    //      height: rem(48);
    //      border-radius: rem(24);
    //      background-color: #FEF3DB;
    //      margin-right: auto;
    //      margin-left: auto;
    //      position: relative;
    //      .part1-dot{
    //        background-color: #FF7B59;
    //        width: rem(10);
    //        height: rem(10);
    //        border-radius: rem(5);
    //        position: absolute;
    //        top: rem(19);
    //        left: rem(16);
    //      }
    //      .part1-text{
    //        font-size: rem(28);
    //        font-family: Source Han Sans CN;
    //        font-weight: 400;
    //        color: #690B00;
    //        line-height: rem(40);
    //        padding-top: rem(7);
    //        position: absolute;
    //        left: rem(51);
    //      }
    //      .text-container{
    //        font-size: rem(36);
    //        font-family: Source Han Sans CN;
    //        font-weight: bold;
    //        color: #E43425;
    //        padding-top: rem(7);
    //        line-height: rem(40);
    //        position: absolute;
    //        right: rem(86);
    //      }
    //      .points-text{
    //        font-size: rem(28);
    //        font-family: Source Han Sans CN;
    //        font-weight: 400;
    //        color: #666666;
    //        padding-top: rem(8);
    //        line-height: rem(40);
    //        position: absolute;
    //        right: rem(20);
    //      }
    //    }
    //  }
    //}
    //.footer-container{
    //  .card-footer{
    //    .footer-title{
    //      width: rem(750);
    //      height: rem(32);
    //      font-size: rem(32);
    //      font-family: Source Han Sans CN;
    //      margin-bottom: rem(32);
    //      font-weight: 400;
    //      color: #8F2400;
    //      text-align:center
    //    }
    //  }
    //  .instruction{
    //    background-image: url('../../assets/images/recommend/instruction2.png');
    //    height: rem(317);
    //    width: rem(750);
    //    margin-right: auto;
    //    margin-left: auto;
    //    margin-bottom: rem(170);
    //    background-size: contain;
    //  }
    //}
    .button-container{
      background-image: url('../../assets/images/recommend/recommend-bottom.png');
      margin-bottom: rem(24);
      width: rem(686);
      height: rem(104);
      margin-right: auto;
      margin-left: auto;
      background-size: contain;
      background-repeat: no-repeat;
      position: fixed;
      bottom: rem(20);
      left: rem(30);
    }
    .hidden-container2{
      .top-image{
        background-image: url('../../assets/images/recommend/top-image.png');
        width: rem(750);
        height: rem(829);
        margin-left: auto;
        margin-right: auto;
        background-size: contain;
        background-repeat: no-repeat;
      }
      .mid-bgc{
        background-image: url('../../assets/images/recommend/mid-bgc.png');
        width: rem(750);
        height: rem(848);
        margin-left: auto;
        margin-right: auto;
        background-size: contain;
        //background-repeat: no-repeat;
        margin-bottom: 0;
        .credit-line{
          width: rem(550);
          height: rem(48);
          border-radius: rem(24);
          background-color: #FEF3DB;
          margin-right: auto;
          margin-left: auto;
          position: relative;
          margin-bottom: rem(16);
          .part1-dot{
            background-color: #FF7B59;
            width: rem(10);
            height: rem(10);
            border-radius: rem(5);
            position: absolute;
            top: rem(19);
            left: rem(16);
          }
          .part1-text{
            font-size: rem(28);
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #690B00;
            line-height: rem(40);
            padding-top: rem(7);
            position: absolute;
            left: rem(51);
          }
          .text-container{
            font-size: rem(36);
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #E43425;
            padding-top: rem(7);
            line-height: rem(40);
            position: absolute;
            right: rem(86);
          }
          .points-text{
            font-size: rem(28);
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
            padding-top: rem(8);
            line-height: rem(40);
            position: absolute;
            right: rem(20);
          }
        }
      }
      .bottom-image{
        background-image: url('../../assets/images/recommend/bottom-bgc.png');
        width: rem(750);
        height: rem(405);
        margin: 0 auto rem(24);
        background-size: contain;
        background-repeat: no-repeat;
        .credit-line{
          width: rem(550);
          height: rem(48);
          border-radius: rem(24);
          background-color: #FEF3DB;
          margin-right: auto;
          margin-left: auto;
          position: relative;
          margin-bottom: rem(16);
          .part1-dot{
            background-color: #FF7B59;
            width: rem(10);
            height: rem(10);
            border-radius: rem(5);
            position: absolute;
            top: rem(19);
            left: rem(16);
          }
          .part1-text{
            font-size: rem(28);
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #690B00;
            line-height: rem(40);
            padding-top: rem(7);
            position: absolute;
            left: rem(51);
          }
          .text-container{
            font-size: rem(36);
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #E43425;
            padding-top: rem(7);
            line-height: rem(40);
            position: absolute;
            right: rem(250);
          }
          .points-text{
            font-size: rem(28);
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
            padding-top: rem(8);
            line-height: rem(40);
            position: absolute;
            right: rem(20);
          }
        }
      }
      //.instruction{
      //  background-image: url('../../assets/images/recommend/instruction.png');
      //  height: rem(505);
      //  width: rem(750);
      //  margin-left: 0;
      //  margin-right: 0;
      //  margin-bottom: rem(170);
      //  background-size: contain;
      //}
    }
    .instruction{
      margin-top: rem(20);
      background-image: url('../../assets/images/recommend/instruction.png');
      height: rem(505);
      width: rem(750);
      margin-left: 0;
      margin-right: 0;
      margin-bottom: rem(170);
      background-size: contain;
    }
  }
  .slide-fade-enter-active {transition: all .2s ease;}
  .slide-fade-leave-active {transition: opacity .5s}
  .slide-fade-enter, .slide-fade-leave-to{opacity: 0}
}
</style>
